<template>
    <div id="error-page">
        <div class="content">
            <h2 class="header" data-text="404" style="background: transparent;">
                404
            </h2>
            <h4 data-text="Opps! Page not found">
                Opps! Page not found
            </h4>
            <p>
                Please contract to the adminstrator
            </p>
        </div>
    </div>
</template>
<script lang="ts">
import './NotFoundComponent.css';
import { defineComponent } from 'vue';

export default defineComponent({
    created() {
    },
    data() {
        return {
        }
    },
    mounted() {
        
    },
    methods: {
        
    }
});
</script>
